import LIST from './lists'
import AUTHORIZED_APPS from './authorizedApps'
import BATCH from './batches'
import CAMPAIGN from './campaign'
import SITES from './sites'
import FILES from './files'
import LANDING_PAGES from './landingpages'

export default {
  LIST,
  AUTHORIZED_APPS,
  BATCH,
  CAMPAIGN,
  SITES,
  FILES,
  LANDING_PAGES,
}
